module.exports = __webpack_public_path__ + "static/media/web5.ee06b0f7.png";